import React from 'react'
import { URL_GET_SOLICITUDES } from '../../router/Url';

export const GetRequest = ({since, until, planta}) => {
    // console.log({since, until, planta});
    return new Promise(async (resolve, reject) => {
      let query = await fetch(URL_GET_SOLICITUDES+'&since='+since+'&until='+until+'&planta='+planta,{
        method: 'GET',
        headers: {
          'authorization': "marcuxo",
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      let responsito = await query.json();
    //   console.log(responsito);
  
      // if(responsito.data.success){
        resolve(responsito)
      // }else{
      //   resolve(responsito.data)
      // }
    })
}
